<template>
	<div id="clientSendtoInputComponent">		
		<div style="position: relative" class="mb-3">
			<div class="form-floating mb-3">
				<input class="form-control form-control-sm rounded-2" :id="idRandom" placeholder="ej: central"
					onfocus="this.select()"
					v-model="searchInput"
					@blur="blur"
					@focus="focusInput=true"
					@keyup="keyupLocal($event)">
				<label :for="idRandom">
					<span>{{ msg }}</span>
				</label>
			</div>
			<button @click="clear" v-show="false" ref="clear">Limpiar</button>
			<ul class="list-result-input" v-show="listClientSendtoSearch.length > 0 && searchInput.length > minShow && focusInput">
				<li v-for="(item, index) in listClientSendtoSearch" :key="index" @click="selectedChurch(item)">
					<div>
						<b>{{ item.sendto }}</b>
					</div>
					<small>{{ item.email }} - {{ item.phone }}</small>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	
	export default {
		name: 'ClientSendtoInputComponent',
		mixins: [mixin],
        props: ['searchClientSendto', 'url', 'msg', 'listClientSendto'],
		data () {
			return {
				data: {
					id: -2,
					string: '',
					item: { id: -2, sendto:'', phone:'', email:'', number_document:'' }
				},
				searchInput: '',
				minShow: 3,
				searching: false,
				focusInput: false,
				idRandom: '',
			}
		},
		computed: {
			listClientSendtoSearch() {
                let listClientSendto = []
				if(this.searchInput.length > this.minShow) {
					listClientSendto = this.listClientSendto.filter(c => c.sendto.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1)
				}
                return listClientSendto
			}
		},
		methods: {
            initComponentLocal() {
				this.idRandom = this.generateString(8)
				if(this.searchClientSendto) {
					this.getAllChurchsLocal()
				}
			},
			clear() {
				this.searchInput = ''
				this.clearData()
			},
			clearData() {
				this.data.string = ''
				this.data.id = -2
				this.data.item = { id: -2, sendto:'', phone:'', email:'', number_document:'' }
				this.$emit('actionSelectItem', this.data)
			},
			blur() {
				setTimeout(() => {
					this.focusInput = false
					if(this.data.id == -2) {
						this.keyupLocal({keyCode: 13})
					}
				}, 300)
			},
			getAllChurchsLocal() {
				if(this.listClientSendto.length == 0) {
					this.getAllChurchs()
				}
			},
			getAllChurchsResultLocal(response){ 
			},
			keyupLocal(event) {
				if(this.data.id > -2) {
					this.clearData()
				} else {
					if(event.keyCode == 13 && this.searchInput.trim().length > 2) {
						let item = {
								sendto: this.searchInput,
								id: 0,
								phone: '',
								email: '',
								number_document: ''
							}
						this.selectedChurch(item)
					}					
				}
			},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'getAllChurchsResult': this.getAllChurchsResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			selectedChurch(item) {
				console.log(item)
                this.data.string = item.sendto
                this.data.id = item.id
				this.data.item = item
				this.searchInput = item.sendto
				this.$emit('actionSelectItem', this.data)
			},
		},
		mounted () {
            this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.list-result-input {
	list-style: none;
	padding: 0px;
	margin-top: -29px;
	border: 1px solid #ccc;
	background-color: white;
	position: absolute;
	z-index: 1;
	width: 100%;
	box-shadow: 1px 1px #ccc;
}
.list-result-input>li {
	padding: 5px 10px;
	border-bottom: 1px solid #ddd;
}
.list-result-input>li:hover {
	background: #5bc0de;
	color:#fff;
	cursor: pointer;
}

</style>
